import React, { useCallback } from 'react';
import { Field } from '@ontruck/orc';

const Input = ({ name, placeholder, value, onChange, warning, className }) => {
  const handleChange = useCallback(
    (_, { value }) => {
      onChange(value);
    },
    [onChange]
  );

  return (
    <span className={className}>
      <Field
        name={name}
        className="input"
        value={value}
        label={placeholder}
        width="S"
        onChange={handleChange}
        invalid={warning}
      />
    </span>
  );
};

export default Input;
